import { Module } from "wrapper6";

var $ = jQuery;

export default class MapWidget extends Module {

    ready(app) {
        window.map_selected_area = ''
        window.onCreateMap = function(elem){
            MapWidget.genFilters(elem);

            $(document).on('click', '.map-marker-select', function(e){
                $('.mtt-map-widget__choice-marker').removeClass('mtt-map-widget__choice-marker--active');
                $(this).addClass('mtt-map-widget__choice-marker--active');
                let marker = window.marker_elem [$(this).data('marker')];
                var center = marker.getCenter();
                e.clientX = center[0];
                e.clientY = center[1];
                elem.regionClickHandler.call(elem, e, marker);

                MapWidget.scrollToMap();
            });
        }

        window.mappopoverclosed = function() {
            $('.mtt-map-widget__choice-marker').removeClass('mtt-map-widget__choice-marker--active');
        }

        window.onDBUpdate = function(elem){
            MapWidget.setMarkers(elem.markers);
        }
    }

    static setMarkers(markers, selected_area){

        let areas = {};
        window.marker_elem = [];

        $('.mtt-map-widget__marker-select').html('')

        for (let i = 0; i < markers.length; i++) {
            let marker = markers[i];
            if(marker.object.area === window.map_selected_area || window.map_selected_area === ''){

                if(marker.object.type === 'office'){
                    if(!areas['Regionale kontorer']){
                        areas['Regionale kontorer'] = {};
                    }
                    areas['Regionale kontorer'][i] = marker;

                } else if(window.map_selected_area !== '') {
                    if(!areas[marker.object.under_region_text]){
                        areas[marker.object.under_region_text] = {};
                    }
                    areas[marker.object.under_region_text][i] = marker;
                }

            } 
        }

        for(let key in areas){
            let elems = areas[key];

            let groups = '';
            for(let elemKey in elems){
                let elem = elems[elemKey];

                let subtitle = elem.object.subtitle !== null ? elem.object.subtitle : '';

                let flag = elem.object.menu_flag ? elem.object.menu_flag[0].medium : null;

                window.marker_elem[elemKey] = elem;

                groups += '<div data-marker="'+elemKey+'" class="mtt-map-widget__choice-marker map-marker-select"><div class="mtt-map-widget__flag-wrap"><img src="'+flag+'" class="mtt-map-widget__flag"/></div><div class="mtt-map-widget__content"><p class="mtt-map-widget__content-title">'+elem.object.title+'</p>';

                if(subtitle && subtitle != '-'){
                    groups += '<p class="mtt-map-widget__content-subtitle">'+subtitle+'</p>';
                }

                groups += '</div></div>';


            };

            let html = '<div class="mtt-map-widget__group"><p class="mtt-map-widget__group-title">'+key+':</p><div class="mtt-map-widget__group-choices">'+groups+'</div></div>';

            if(key === 'Regionale kontorer'){
                $('.mtt-map-widget__marker-select').prepend(html)
            } else {
                $('.mtt-map-widget__marker-select').append(html)
            }

        };

    }

    static genFilters(mainElem){

        let filters = null;
        for (let i = 0; i < mainElem.filtersSchema.schema.length; i++) {
            let filter = mainElem.filtersSchema.schema[i];
            if(filter.name === 'area'){
                filters = filter.options;
            }
        }

        for (let i = 0; i < filters.length; i++) {
            let filter = filters[i];
            let cls = i == 0 ? ' active' : '';
            let html = '<div class="area'+cls+'"><h3 class="area-text">'+filter.label+'</h3></div>';
            let elem = $('.mtt-map-widget__area-filter').append(html);

            $(elem[0].lastChild).on('click', function (e) {
                MapWidget.setSelectedBorder(this, filter, mainElem);
            });

            if (i === 0) {
                window.setTimeout(() => {
                    $('.mtt-map-widget__area-filter .area')[0].click();
                    window.setTimeout(() => {
                        MapWidget.hideLoader(this);
                    }, 1000);
                }, 300);
            }
        }
    }

    static setSelectedBorder(selected, filters, mainElem){
        let input = $('input[data-parameter-name="area"][value="'+filters.value+'"]')[0];
        if (input) {
            input.click();
        }

        let areas = $('.mtt-map-widget__area-filter .area');
        let calcWidth = 0;
        let stop = false;
        for (let i = 0; i < areas.length; i++) {
            let elem = areas[i];
            if(elem === selected || stop){
                break;
            }
            calcWidth += elem.offsetWidth+32;
        }

        $(selected).addClass('active').siblings().removeClass('active');

        // $('.mtt-map-widget__area-filter .bottom-border').css('width', selected.offsetWidth);
        // $('.mtt-map-widget__area-filter .bottom-border').css('left', calcWidth);

        window.map_selected_area = filters.value;
    }

    static hideLoader() {
        $('.mtt-map-widget__loader').removeClass('mtt-map-widget__loader--show');
    }

    static scrollToMap() {
        if (MapWidget.getScreenWidth() <= 1050) {
            setTimeout(() => {
                $('html, body').animate({
                    scrollTop: $('.mtt-map-widget__map .mapsvg-popover').offset().top - 120
                }, 1000);
            }, 300);
        }
    }

    /**
     * Get screen width
     */
    static getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}
